import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';
import { MapLocation, mapLocationSchema } from 'app/agriculture/queries/types/MapLocation';

export interface LocationSnapshot extends Snapshot {
    altitude: number | null;
    radius: number | null;
    speed: number | null;
    location: MapLocation | null;
}

export const locationSnapshotSchema = snapshotSchema.extend({
    altitude: z.number().nullable(),
    radius: z.number().nullable(),
    speed: z.number().nullable(),

    location: mapLocationSchema.nullable(),
});

export const mockLocationSnapshot = ({
    altitude = 1.0,
    radius = 2.0,
    speed = 3.0,

    location = { latitude: 1.0, longitude: 1.0 },

    ...snapshot
}: Partial<LocationSnapshot> = {}): LocationSnapshot => ({
    ...mockSnapshot(snapshot),

    altitude,
    speed,
    radius,

    location,
});
